export const getNameErrorKey = (name: string, names: string[]) => {
  if (name === undefined || name.trim() === "") {
    return "you.must.have.a.name";
  }
  if (name.trim() === "﷽﷽") {
    return "no.hacking";
  }
  if (name.length > 25) {
    return "name.too.long";
  }
  if (name.toLowerCase() === "alex" || name.toLowerCase() === "alexander") {
    return "no.alex";
  }
  if (names.some((n) => n === name)) {
    return "this.name.is.already.taken";
  }
  const alphaRegexp = new RegExp(
    /^([-.a-zA-Z 0-9ÇüéâäàåçêëèïîíìÄÅÉæÆôöòûùÖÜáíóúñÑÀÁÂÃÈÊËÌÍÎÏÐÒÓÔÕØÙÚÛÝßãðõøýþÿ!?=+@$%:;%&#'"()]+)$/
  );
  if (!alphaRegexp.test(name.toLowerCase().trim())) {
    return "non.alpha.character";
  }
};
